import { gql } from '@apollo/client'

export const DELETE_DASHBOARD_MUTATION = gql`
  mutation deleteDashboard($workspaceJobInput: EditWorkspaceJobInput!) {
    editWorkspaceJob(workspaceJob: $workspaceJobInput) {
      id
      isActive
      name
    }
  }
`
